const VBackgroundPreloadMixin = {
	async prefetch () {
		if (process.server) {
			this.$app.websiteHeadManager.addVBackgroundImagePreload(this.$app, this.background)
		}
	}
}

export default VBackgroundPreloadMixin
